import React, { FunctionComponent } from 'react'

import { withSuspense } from '../../utils/withSuspense'

const SparklesAvatarIconImage = withSuspense({
  component: React.lazy(() => import('./SparklesAvatarIconImage')),
})

export interface SparklesAvatarIconProps {
  size?: number | string
}

// This will work with Avatars of height=77 and width=77, see SparklesAvatarIcon.stories.tsx for how to use
export const SparklesAvatarIcon: FunctionComponent<SparklesAvatarIconProps> = () => {
  return <SparklesAvatarIconImage />
}
